// Performance constants from requirements
export const PERFORMANCE_TARGETS = {
    VISUAL_FEEDBACK_MS: 100,
    BACKEND_RESPONSE_MS: 500,
    STATE_UPDATE_MS: 200,
    INITIAL_LOAD_MS: 3000,
    MIN_FPS: 30
};
// Connection status constants
export const CONNECTION_STATUS = {
    CONNECTED: 'connected',
    DISCONNECTED: 'disconnected',
    CONNECTING: 'connecting',
    DISCONNECTING: 'disconnecting',
    ERROR: 'error'
};
// Source/Destination types
export const SIGNAL_TYPES = {
    VIDEO: 'video',
    AUDIO: 'audio',
    DATA: 'data'
};
